var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28420_118096",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28420_118096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0508 20C9.81745 20 7.91745 19.225 6.35078 17.675C4.78411 16.125 4.00078 14.2333 4.00078 12V11.825L3.10078 12.725C2.91745 12.9083 2.68411 13 2.40078 13C2.11745 13 1.88411 12.9083 1.70078 12.725C1.51745 12.5417 1.42578 12.3083 1.42578 12.025C1.42578 11.7417 1.51745 11.5083 1.70078 11.325L4.30078 8.725C4.50078 8.525 4.73411 8.425 5.00078 8.425C5.26745 8.425 5.50078 8.525 5.70078 8.725L8.30078 11.325C8.48411 11.5083 8.57578 11.7417 8.57578 12.025C8.57578 12.3083 8.48411 12.5417 8.30078 12.725C8.11745 12.9083 7.88411 13 7.60078 13C7.31745 13 7.08411 12.9083 6.90078 12.725L6.00078 11.825V12C6.00078 13.6667 6.58828 15.0833 7.76328 16.25C8.93828 17.4167 10.3674 18 12.0508 18C12.3174 18 12.5799 17.9833 12.8383 17.95C13.0966 17.9167 13.3508 17.8583 13.6008 17.775C13.8841 17.6917 14.1508 17.7 14.4008 17.8C14.6508 17.9 14.8424 18.075 14.9758 18.325C15.1091 18.5917 15.1216 18.8542 15.0133 19.1125C14.9049 19.3708 14.7091 19.5417 14.4258 19.625C14.0424 19.7583 13.6508 19.8542 13.2508 19.9125C12.8508 19.9708 12.4508 20 12.0508 20ZM11.9508 6C11.6841 6 11.4216 6.01667 11.1633 6.05C10.9049 6.08333 10.6508 6.14167 10.4008 6.225C10.1174 6.30833 9.84661 6.3 9.58828 6.2C9.32995 6.1 9.13411 5.925 9.00078 5.675C8.86745 5.425 8.85495 5.17083 8.96328 4.9125C9.07161 4.65417 9.25911 4.48333 9.52578 4.4C9.92578 4.26667 10.3258 4.16667 10.7258 4.1C11.1258 4.03333 11.5341 4 11.9508 4C14.1841 4 16.0841 4.775 17.6508 6.325C19.2174 7.875 20.0008 9.76667 20.0008 12V12.175L20.9008 11.275C21.0841 11.0917 21.3174 11 21.6008 11C21.8841 11 22.1174 11.0917 22.3008 11.275C22.4841 11.4583 22.5758 11.6917 22.5758 11.975C22.5758 12.2583 22.4841 12.4917 22.3008 12.675L19.7008 15.275C19.5008 15.475 19.2674 15.575 19.0008 15.575C18.7341 15.575 18.5008 15.475 18.3008 15.275L15.7008 12.675C15.5174 12.4917 15.4258 12.2583 15.4258 11.975C15.4258 11.6917 15.5174 11.4583 15.7008 11.275C15.8841 11.0917 16.1174 11 16.4008 11C16.6841 11 16.9174 11.0917 17.1008 11.275L18.0008 12.175V12C18.0008 10.3333 17.4133 8.91667 16.2383 7.75C15.0633 6.58333 13.6341 6 11.9508 6Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.74c2d2cee8901c78b0cd20d34248b532.svg";
export { ForwardRef as ReactComponent };